import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Rating from '@material-ui/lab/Rating';
// import amazon from "amazon-product-api"


// interface ExpandMoreProps extends IconButtonProps {
//   expand: boolean;
// }



const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default function ProductCard(p) {
  const [expanded, setExpanded] = React.useState(false);
  const [priceObjects,setPriceObjects] = React.useState(null)
  
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  const clickLog = () =>{
    console.log(p.amazonObj)
    console.log(p)
  }
  
  return (
    <div id='productsC' onClick={clickLog}>
    <Card sx={{ maxWidth: 300,
    marginLeft: 0, }}
    key={p.amazonObj}>
      <CardHeader
        avatar={
          <Avatar  aria-label="recipe">
            <CardMedia
        component="img"
        height="194"
        // image={require('./amazon-logo.png')}
        alt="Paella dish"
      />
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title="Shrimp and Chorizo Paella"
        subheader="September 14, 2016"
      />
      <CardMedia
        component="img"
        height="194"
        image="/static/images/cards/paella.jpg"
        alt="Paella dish"
      />
     
      <CardContent>
      <Rating name={'rating'} value={2} size={'small'} />
        <Typography variant="body2" color="text.secondary">
          This impressive paella is a perfect party dish and a fun meal to cook THIS IS GONNA BE THE DESCRIPTION
          together with your guests. Add 1 cup of frozen peas along with the mussels,
          if you like.
        </Typography>
      </CardContent>
      <CardActions disableSpacing>
        {/* <IconButton aria-label="add to favorites">
          <FavoriteIcon />
        </IconButton> */}
        <IconButton aria-label="share">
          <ShareIcon />
        </IconButton>

      </CardActions>
      
    </Card>

{/* <Card sx={{ maxWidth: 300,
  marginLeft: 10, }}>
    <CardHeader
      avatar={
        <Avatar  aria-label="recipe">
          <CardMedia
      component="img"
      height="194"
      image={require('./ebay-logo.png')}
      alt="Paella dish"
    />
        </Avatar>
      }
      action={
        <IconButton aria-label="settings">
          <MoreVertIcon />
        </IconButton>
      }
      title="Shrimp and Chorizo Paella"
      subheader="September 14, 2016"
    />
    <CardMedia
      component="img"
      height="194"
      image="/static/images/cards/paella.jpg"
      alt="Paella dish"
    />
   
    <CardContent>
      <Typography variant="body2" color="text.secondary">
        This impressive paella is a perfect party dish and a fun meal to cook THIS IS GONNA BE THE DESCRIPTION
        together with your guests. Add 1 cup of frozen peas along with the mussels,
        if you like.
      </Typography>
    </CardContent>
    <CardActions disableSpacing>
      {/* <IconButton aria-label="add to favorites">
        <FavoriteIcon />
      </IconButton> 
      <IconButton aria-label="share">
        <ShareIcon />
      </IconButton>

    </CardActions>
    
  </Card>


  <Card sx={{ maxWidth: 300,
  marginLeft: 10,bgcolor: '#EFEFEF' }}>
    <CardHeader
      avatar={
        <Avatar  aria-label="recipe">
          <CardMedia
      component="img"
      height="194"
      image={require('./walmart-logo.png')}
      alt="Paella dish"
    />
        </Avatar>
      }
      action={
        <IconButton aria-label="settings">
          <MoreVertIcon />
        </IconButton>
      }
      title="Shrimp and Chorizo Paella"
      subheader="September 14, 2016"
    />
    <CardMedia
      component="img"
      height="194"
      image="/static/images/cards/paella.jpg"
      alt="Paella dish"
    />
   
    <CardContent>
      <Typography variant="body2" color="text.secondary">
        This impressive paella is a perfect party dish and a fun meal to cook THIS IS GONNA BE THE DESCRIPTION
        together with your guests. Add 1 cup of frozen peas along with the mussels,
        if you like.
      </Typography>
    </CardContent>
    <CardActions disableSpacing>
      
      <IconButton aria-label="share">
        <ShareIcon />
      </IconButton>

    </CardActions>
    
  </Card> */}

  </div>
  );
}